<template>
  <div class="filter-tips" :class="[isNowrap && 'is-nowrap', themeClass]" v-if="isInit">
    <slot name="head-content" v-if="$slots['head-content']"></slot>

    <el-tag
      class="filter-item sort-item"
      size="small"
      v-if="sortInfoCustom.length > 0"
      :closable="showCloseBtn"
      @close="$emit('delSortCustom')"
    >
      <span>{{ getSortInfoCustomText(sortInfoCustom) }}</span>
    </el-tag>

    <el-tag
      class="filter-item sort-item"
      size="small"
      v-if="Object.keys(courseSortInfo || {}).length > 0"
      :closable="byCourse && showCloseBtn"
      @close="$emit('delSort', { action: courseSortInfo.action, fieldInfo: courseSortInfo.fieldInfo })"
    >
      <i class="iconfont" :class="courseSortInfo.action === 'asc' ? 'iconshengxu' : 'iconjiangxu'"></i>
      <span>：{{ courseSortInfo.fieldInfo.title }}</span>
    </el-tag>

    <el-tag
      class="filter-item sort-item"
      size="small"
      v-if="Object.keys(researchSortInfo || {}).length > 0"
      :closable="showCloseBtn"
      @close="$emit('delSort', { action: researchSortInfo.action, fieldInfo: researchSortInfo.fieldInfo })"
    >
      <i class="iconfont" :class="researchSortInfo.action === 'asc' ? 'iconshengxu' : 'iconjiangxu'"></i>
      <span>：{{ researchSortInfo.fieldInfo.title }}</span>
    </el-tag>

    <template v-if="courseFilterArr.length > 0">
      <template v-for="(filterItem, filterIndex) in courseFilterArr">
        <el-tag
          class="filter-item normal-item"
          :class="[getThemeClass(filterItem), filterItem.isTextFilter && 'is-text-filter-item']"
          size="small"
          :key="`course_filter_${filterIndex}`"
          :closable="byCourse && showCloseBtn"
          @click="tapFilterItem(filterItem)"
          @close="$emit('delFilter', { type: 'course', index: filterIndex })"
        >
          <el-tooltip
            effect="dark"
            :open-delay="300"
            placement="bottom"
            :disabled="!collapseTextFilter || !filterItem.isTextFilter || filterItem.info.selects.length === 1"
          >
            <div slot="content" :style="{ maxWidth: '400px' }">
              <span>{{ getParaText(filterItem, paragraphArr, false) }}</span>
            </div>
            <span v-if="!filterItem.isTextFilter">
              <span>{{ filterItem | toTipFilter(paragraphArr) }}</span>
            </span>
            <span v-else>
              <span>{{ getParaText(filterItem, paragraphArr, collapseTextFilter) }}</span>
              <div
                class="collapse-para-count"
                v-if="collapseTextFilter && filterItem.isTextFilter && filterItem.info.selects.length > 1"
              >
                <span>+</span>
                <span>{{ filterItem.info.selects.length - 1 }}</span>
              </div>
              <div class="filter-item-text">{{ filterItem.info.text }}</div>
            </span>
          </el-tooltip>
        </el-tag>
      </template>
    </template>
    <template v-if="researchFilterArr.length > 0">
      <template v-for="(filterItem, filterIndex) in researchFilterArr">
        <el-tag
          class="filter-item normal-item"
          :class="[getThemeClass(filterItem), filterItem.isTextFilter && 'is-text-filter-item']"
          size="small"
          :key="`research_filter_${filterIndex}`"
          :closable="showCloseBtn"
          @click="tapFilterItem(filterItem)"
          @close="$emit('delFilter', { type: 'research', index: filterIndex })"
        >
          <el-tooltip
            effect="dark"
            :open-delay="300"
            placement="bottom"
            :disabled="!collapseTextFilter || !filterItem.isTextFilter || filterItem.info.selects.length === 1"
          >
            <div slot="content" :style="{ maxWidth: '400px' }">
              <span>{{ getParaText(filterItem, paragraphArr, false) }}</span>
            </div>
            <span v-if="!filterItem.isTextFilter">
              <span>{{ filterItem | toTipFilter(paragraphArr) }}</span>
            </span>
            <span v-else>
              <span>{{ getParaText(filterItem, paragraphArr, collapseTextFilter) }}</span>
              <div
                class="collapse-para-count"
                v-if="collapseTextFilter && filterItem.isTextFilter && filterItem.info.selects.length > 1"
              >
                <span>+</span>
                <span>{{ filterItem.info.selects.length - 1 }}</span>
              </div>
              <div class="filter-item-text">{{ filterItem.info.text }}</div>
            </span>
          </el-tooltip>
        </el-tag>
      </template>
    </template>

    <!-- <div
      class="condition-item"
      v-for="(courseTipItem, courseTipIndex) in courseFilterTips"
      :key="`course_${courseTipIndex}`"
    >
      <span>{{ courseTipItem.tipText }}</span>
    </div> -->

    <slot name="btn"></slot>
  </div>
</template>

<script>
import converter from '@/lib/converter';
import { services } from '@/service';
import { groupBy } from 'lodash';
import { fetchCourseFilterTips, getSortWayOptions } from '@/lib/utils';

export default {
  data() {
    return {
      isInit: false,
      paragraphArr: []
    };
  },
  props: {
    courseId: {
      type: String,
      required: true
    },
    byCourse: {
      type: Boolean,
      default: false
    },
    showCloseBtn: {
      type: Boolean,
      default: true
    },
    instrumentType: {
      type: String,
      default: ''
    },
    courseConditionArr: {
      type: Array,
      default: () => []
    },
    courseFilterArr: {
      type: Array,
      default: () => []
    },
    courseSortInfo: {
      type: Object,
      default: () => ({})
    },
    researchFilterArr: {
      type: Array,
      default: () => []
    },
    researchSortInfo: {
      type: Object,
      default: () => ({})
    },
    sortInfoCustom: {
      type: Array,
      default: () => []
    },
    isNowrap: {
      type: Boolean,
      default: false
    },
    themeClass: {
      type: String,
      default: ''
    },
    fieldThemeEnum: {
      type: Object,
      default: () => ({})
    },
    collapseTextFilter: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    toTipFilter(item, paragraphArr) {
      if (!item.fieldType) {
        return converter.toTip(item, paragraphArr);
      }
      const joinText = item.op_type === 'and' ? '且' : '或';
      const tipArr = item.fieldArr.map(filterItem => converter.toTip(filterItem, paragraphArr));
      return tipArr.join(` ${joinText} `);
    }
  },
  computed: {
    courseFilterTips() {
      return fetchCourseFilterTips({
        instrumentType: this.instrumentType,
        filterList: this.courseConditionArr,
        paragraphArr: this.paragraphArr
      });
    }
  },
  async mounted() {
    this.paragraphArr = await services.labelRelation.getParagraph(this.courseId);
    this.isInit = true;
  },
  methods: {
    getThemeClass(filterItem) {
      if (filterItem.columnInfo) {
        return this.fieldThemeEnum[filterItem.columnInfo._id] || this.fieldThemeEnum[filterItem.columnInfo.columnKey];
      }

      if (filterItem.isLabelFilter) {
        return (
          this.fieldThemeEnum[filterItem.info.fieldDetail._id] ||
          this.fieldThemeEnum[filterItem.info.fieldDetail.columnKey]
        );
      }

      return '';
    },
    getParaText(item, paragraphArr, collapseTextFilter) {
      if (!item.isTextFilter) {
        return '';
      }
      if (collapseTextFilter) {
        const paragraphItem = paragraphArr.find(paragraphItem => paragraphItem.key === item.info.selects[0]);
        return (paragraphItem && paragraphItem.value) || '全文';
      } else {
        return item.info.selects
          .map(paragraphKey => {
            const paragraphItem = paragraphArr.find(paragraphItem => paragraphItem.key === paragraphKey);
            return (paragraphItem && paragraphItem.value) || '全文';
          })
          .join('、');
      }
    },
    tapFilterItem(filterItem) {
      if (filterItem.fieldType === 'group' || filterItem.isTextFilter || filterItem.isLabelFilter) {
        return;
      }
      this.$emit('updFilter', filterItem);
    },
    getMustType(val) {
      if (val) {
        const res = val.replace(/-/g, '排除');
        return res;
      } else {
        return '';
      }
    },
    isArrayCheck(arr) {
      if (arr) {
        return Array.isArray(arr);
      } else {
        return false;
      }
    },
    groupByKey(arr, key) {
      if (arr && key) {
        return groupBy(arr, key);
      } else {
        return [];
      }
    },
    showAllParaCheck(arr) {
      if (arr) {
        const hadRes = arr.filter(paraItem => {
          return paraItem.value;
        });
        return hadRes.length > 0;
      } else {
        return false;
      }
    },
    getSortInfoCustomText(sortInfoCustomArr) {
      const textArr = [];

      sortInfoCustomArr.forEach(item => {
        const sortWayOptions = getSortWayOptions(item.fieldInfo);
        const sortWayItem = sortWayOptions.find(o => o.value === item.sortWay);
        let text = item.fieldInfo.title;
        if (sortWayItem) {
          text = `${text}-${sortWayItem.label}`;
        }
        textArr.push(text);
      });

      return textArr.join('、');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../views/dataCleaner/index';
.filter-tips {
  display: flex;

  &:not(.is-nowrap) {
    flex-wrap: wrap;

    .filter-item {
      max-width: 100%;
    }
  }

  & > span,
  & > div {
    margin-bottom: 10px;
  }

  &.is-nowrap {
    & > span,
    & > div {
      margin-bottom: 0;
    }
  }

  .collapse-para-count {
    display: inline-block;
  }
  .filter-item-text {
    display: inline-block;
  }

  .filter-item {
    box-sizing: border-box;
    position: relative;
    /* max-width: 100%; */
    font-size: 0;
    vertical-align: middle;
    padding-right: 20px;
    margin-right: 10px;

    span {
      font-size: 12px;
    }

    & > span {
      max-width: 100%;
      display: inline-block;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      vertical-align: middle;
    }

    .filter-tag-text {
      display: inline-block;
      max-width: 100%;
    }

    ::v-deep .el-tag__close {
      position: absolute;
      right: 4px;
      top: calc(50% + 1px);
      transform: translateY(-50%) scale(0.8);
    }

    &:first-child {
      margin-left: 0;
    }

    &.normal-item {
      cursor: pointer;
    }

    &.sort-item {
      line-height: 22px;
      background-color: #fff;
      border: 1px solid #1991fb;

      .iconfont {
        font-size: 14px;
        vertical-align: middle;
      }
    }

    .el-tooltip > span {
      white-space: nowrap;
    }
  }

  .condition-item {
    display: inline-block;

    span {
      box-sizing: border-box;
      display: inline-block;
      padding: 0 12px;
      line-height: 22px;
      height: fit-content;
      color: #3d465a;
      background: #e7eaf1;
      border: 1px solid #e9e9eb;
      font-size: 12px;
      border-radius: 4px;
      margin-right: 10px;
    }
  }

  &.theme-2 {
    ::v-deep .filter-item {
      background-color: #fff;
      border-radius: 2px;
      color: #2c3443;
      border-color: #2c3443;
      padding-right: 34px;

      .el-tag__close {
        top: 0;
        right: 0;
        transform: scale(1);
        width: 24px;
        height: 22px;
        line-height: 22px;
        color: #fff;
        border-radius: 0;
        background-color: #2c3443;
      }
      &.is-text-filter-item {
        color: #ee813b;
        border-color: #ee813b;
        padding-right: 24px;
        .el-tag__close {
          background-color: #ee813b;
        }

        .collapse-para-count {
          display: inline-block;
          color: #ee813b;
          font-size: 14px;
          line-height: 18px;
          background-color: rgba(#ee813b, 0.1);
          margin-left: 4px;
          padding: 0 5px;
          transform: translateY(1px);
        }

        .filter-item-text {
          display: inline-block;
          color: #fff;
          background-color: #ee813b;
          padding: 0px 10px;
          transform: translateX(10px);
        }
      }
    }
  }
}

// el-tag换行
::v-deep .el-tag {
  height: auto;
  span {
    white-space: normal;
  }
}
</style>
